import { render, staticRenderFns } from "./srpite-setting.vue?vue&type=template&id=40bb814a&scoped=true&"
import script from "./srpite-setting.vue?vue&type=script&lang=js&"
export * from "./srpite-setting.vue?vue&type=script&lang=js&"
import style0 from "./srpite-setting.vue?vue&type=style&index=0&id=40bb814a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb814a",
  null
  
)

export default component.exports